/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Zipcityofpartner3Inputs */

const de__field_zipcityofpartner3 = /** @type {(inputs: _Field_Zipcityofpartner3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLZ & Stadt`)
};

/**

* @param {_Field_Zipcityofpartner3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_zipcityofpartner3 = /** @type {((inputs?: _Field_Zipcityofpartner3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Zipcityofpartner3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_zipcityofpartner3(inputs)
});
export { _field_zipcityofpartner3 as "_field_zipCityOfPartner" }